// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Icon$OrcaPaymentPage from "../Icon.bs.js";
import * as Radio$OrcaPaymentPage from "./Radio.bs.js";
import * as RenderIf$OrcaPaymentPage from "./RenderIf.bs.js";
import * as CardUtils$OrcaPaymentPage from "../CardUtils.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";
import * as PaymentUtils$OrcaPaymentPage from "../Utilities/PaymentUtils.bs.js";

function Accordion(props) {
  var isActive = props.isActive;
  var paymentOption = props.paymentOption;
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var themeObj = match.themeObj;
  var match$1 = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.optionAtom);
  var layoutClass = CardUtils$OrcaPaymentPage.getLayoutClass(match$1.layout);
  var match$2 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.selectedOptionAtom);
  var setSelectedOption = match$2[1];
  var match$3 = React.useMemo((function () {
          if (isActive) {
            return [
                    "AccordionItem--selected",
                    "AccordionItemLabel--selected",
                    "AccordionItemIcon--selected",
                    true
                  ];
          } else {
            return [
                    "",
                    "",
                    "",
                    false
                  ];
          }
        }), [isActive]);
  var match$4 = PaymentUtils$OrcaPaymentPage.getDisplayNameAndIcon(match$1.customMethodNames, paymentOption.paymentMethodName, paymentOption.displayName, paymentOption.icon);
  var icon = match$4[1];
  return React.createElement("div", {
              className: "AccordionItem flex flex-col",
              style: {
                border: "1px solid " + themeObj.borderColor,
                borderBottomStyle: props.borderBottom ? "solid" : "hidden",
                cursor: "pointer",
                marginBottom: layoutClass.spacedAccordionItems ? themeObj.spacingAccordionItem : "",
                minHeight: "60px",
                width: "-webkit-fill-available",
                borderRadius: props.borderRadiusStyle
              },
              onClick: (function (param) {
                  setSelectedOption(function (param) {
                        return paymentOption.paymentMethodName;
                      });
                })
            }, React.createElement("div", {
                  className: "flex flex-row items-center " + match$3[0],
                  style: {
                    columnGap: themeObj.spacingUnit
                  }
                }, React.createElement(RenderIf$OrcaPaymentPage.make, {
                      condition: layoutClass.radios,
                      children: React.createElement(Radio$OrcaPaymentPage.make, {
                            checked: match$3[3]
                          })
                    }), React.createElement("div", {
                      className: "AccordionItemIcon " + match$3[2] + " flex items-center relative"
                    }, icon !== undefined ? Caml_option.valFromOption(icon) : "<icon>", React.createElement(RenderIf$OrcaPaymentPage.make, {
                          condition: layoutClass.showCheckedIconForSelection && isActive,
                          children: React.createElement("div", {
                                className: "AccordionItemSelectionIcon absolute"
                              }, React.createElement(Icon$OrcaPaymentPage.make, {
                                    name: "checked-selection",
                                    size: 14
                                  }))
                        })), React.createElement("div", {
                      className: "AccordionItemLabel " + match$3[1] + " flex items-center"
                    }, paymentOption.paymentMethodName === "card" ? match.localeString.card : match$4[0])), React.createElement(RenderIf$OrcaPaymentPage.make, {
                  condition: match$2[0] === paymentOption.paymentMethodName,
                  children: React.createElement("div", {
                        className: "w-full"
                      }, props.checkoutEle)
                }));
}

var make = Accordion;

export {
  make ,
}
/* react Not a pure module */
